<template>
  <div>
    <p
      class="process_list"
      v-if="
        $store.getters.allAuthUser"
      style="
        background-color: #fff5e6;
        border-color: #ffebcc;
        padding: 5px;
        margin-bottom: 10px;
      "
    >
      <i class="el-icon-warning" style="color: #f8b762; margin: 0 10px"></i>
      <span class="process_list_num">1</span>
      <span v-if="isInDingTalk">创建模板</span>
      <a v-else href="https://www.junziqian.com/help_detail-39.html" target="_blank">创建模板</a>
      <i class="el-icon-right icon_size"></i>
      <span class="process_list_num">2</span>
      <span v-if="isInDingTalk">授权给成员使用</span>
      <a v-else href="https://www.junziqian.com/help_detail-41.html" target="_blank">授权给成员使用</a>
    </p>
    <el-tabs v-model="tabAct" style="background-color: #ffffff; min-height: calc(100vh - 210px);">
      <!--
        拥有某个权限可以显示。
        为了兼容以前的数据，在两个子权限都没有的情况下，可以显示出来
        （如果只有父级权限说明是以前的数据。可以拥有子权限）
        -->
      <!-- v-if="perms.includes(gantConf.tempManageSub)" 模板管理 -->
      <el-tab-pane
        name="mianSign"
        key="template_mian"
      >
        <temp-manage v-if="tabAct === 'mianSign'" @callbackFn="callbackFn" disabled></temp-manage>
      </el-tab-pane>
      <!--      <el-tab-pane-->
      <!--        v-if="showGrant"-->
      <!--        label="授权给我的模板"-->
      <!--        name="grantToMe"-->
      <!--        key="template_toMe"-->
      <!--      >-->
      <!--        <temp-me></temp-me>-->
      <!--      </el-tab-pane>-->
      <!-- <el-tab-pane label="" name="grant" key="template_grant" disabled>
        <temp-grant
          :tabAct.sync="tabAct"
          :defaultTemId="defaultTemId"
        ></temp-grant>
      </el-tab-pane> -->
    </el-tabs>
  </div>
</template>

<script>
// 组件
import tempGrant from "../../components/console/template/tempGrant.vue";
import tempManage from "../../components/console/template/tempManage.vue";
import tempMe from "../../components/console/template/tempMe.vue";
import { gantConf } from "../../assets/js/utils/jurisdiction";
import { mapGetters } from "vuex";
import { isInDingTalk } from "../../assets/js/utils/ding-env";

export default {
  data () {
    return {
      isInDingTalk,
      tabAct: "mianSign",
      gantConf,
      defaultTemId: 0,
    };
  }, // data end
  computed: {
    ...mapGetters(["allAuthUser", "currentAuthUser"]),
    showGrant () {
      // 0 个人(有企业)--true 1 企业: false
      let account = this.allAuthUser.manCorpUser;
      let current = this.currentAuthUser;
      let grant = !account || account.corpId != current.corpId;
      return grant;
    },
    perms () {
      return this.currentAuthUser.perms ? this.currentAuthUser.perms : [];
    }
  },
  components: { tempGrant, tempManage, tempMe },
  methods: {
    callbackFn(val) {
      this.defaultTemId = val;
      this.tabAct = 'grant';
    },
    updetActive () {
      let query = this.$route.query.activeName,
        comp =
          !this.$store.getters.allAuthUser.manCorpUser ||
            this.$store.getters.allAuthUser.manCorpUser.corpId !=
            this.$store.getters.currentAuthUser.corpId
            ? "grantToMe"
            : "mianSign";
      // this.tabAct = query ? query : comp;
      return query ? query : comp;
    }
  }
};
</script>
<style lang="less" scoped>
  /deep/ .el-tabs__nav-scroll {
    height: 0;
  }
</style>
<style lang="less">
.el-tabs__header {
  margin: 0;
}
.el-tabs--bottom .el-tabs__header.is-bottom {
  margin-top: 0;
}
.el-tabs__nav-scroll {
  background-color: #fff;
}
.el-tabs__item {
  font-weight: bold;
  font-size: 15px;
  padding: 0 12px !important;
}
.el-tabs__active-bar {
  display: none;
}
.el-tabs__item.is-active {
  color: #ec1c1c;
}
.el-tabs__item:hover {
  color: #ec1c1c;
}
.el-tabs__nav-wrap::after {
  height: 1px;
}
.process_list {
  color: #606266;
  font-size: 14px;
  .process_list_num {
    display: inline-block;
    width: 14px;
    height: 14px;
    line-height: 14px;
    text-align: center;
    border: 2px solid #606266;
    border-radius: 50%;
    margin-right: 6px;
  }
  .icon_size {
    margin: 0 20px;
    font-weight: bold;
    font-size: 16px;
  }
}
</style>



// WEBPACK FOOTER //
// pages/console/template.vue